import cx from "classnames";

import styles from "./Preloader.scss";

export interface PreloaderProps {
  inverted?: boolean;
  size?: "large" | "medium" | "small";
  customStyles?: string;
}

const Preloader = ({ inverted = false, size = "medium", customStyles }: PreloaderProps) => (
  <div
    className={cx(
      styles.preloader,
      {
        [styles["preloader--inverted"]]: inverted,
        [styles[`preloader--${size}`]]: size !== "medium"
      },
      customStyles
    )}
    data-testid="preloader"
  />
);

export default Preloader;
